module.exports = __webpack_public_path__ + "img/zhishou.f4adfc5e.svg";